<template>
  <div>
    <b-table :data="emissionsPostes" hoverable>
      <b-table-column
        v-slot="props"
        field="poste"
        width="150"
        :label="$t('compCarbonResultsRegulatoryInventory.label-1')"
        centered
      >
        <span v-if="props.row.poste !== 'Sous-total'">#</span
        >{{ props.row.poste }}
      </b-table-column>
      <b-table-column
        field="posteDef"
        width="300"
        :label="$t('compCarbonResultsRegulatoryInventory.label-2')"
        v-slot="props"
      >
        <span v-if="props.row.posteDef.length < 37">
          {{ props.row.posteDef }}
        </span>
        <span v-else>
          <b-tooltip multilined :label="props.row.posteDef" type="is-black">
            {{ props.row.posteDef | truncate(35) }}
          </b-tooltip>
        </span>
      </b-table-column>
      <b-table-column
        field="scope"
        :label="$t('compCarbonResultsRegulatoryInventory.label-3')"
        centered
        v-slot="props"
      >
        <span class="tag is-success" v-if="props.row.cat === '1'">
          Cat. {{ props.row.cat }}
        </span>
        <span class="tag is-info" v-if="props.row.cat === '2'">
          Cat. {{ props.row.cat }}
        </span>
        <span class="tag is-warning" v-if="props.row.cat === '3'">
          Cat. {{ props.row.cat }}
        </span>
        <span class="tag is-secondary" v-if="props.row.cat === '4'">
          Cat. {{ props.row.cat }}
        </span>
        <span class="tag is-danger" v-if="props.row.cat === '5'">
          Cat. {{ props.row.cat }}
        </span>
        <span class="tag is-dark" v-if="props.row.cat === '6'">
          Cat. {{ props.row.cat }}
        </span>
      </b-table-column>
      <b-table-column field="co2" label="CO2" numeric v-slot="props">
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsRegulatoryInventory.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsRegulatoryInventory.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.co2) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column field="ch4" label="CH4" numeric v-slot="props">
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsRegulatoryInventory.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsRegulatoryInventory.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.ch4) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column field="n2o" label="N2O" v-slot="props" numeric>
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsRegulatoryInventory.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsRegulatoryInventory.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.n2o) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column
        field="other"
        v-slot="props"
        :label="$t('compCarbonResultsRegulatoryInventory.label-4')"
        numeric
      >
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsRegulatoryInventory.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsRegulatoryInventory.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.other) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column
        field="total"
        :label="$t('compCarbonResultsRegulatoryInventory.label-5')"
        v-slot="props"
        width="150"
        numeric
      >
        <span v-if="!props.row.computed">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsRegulatoryInventory.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsRegulatoryInventory.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ Math.round(props.row.intensity.intensity) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column field="poste" label="" centered> </b-table-column>
      <template v-slot:footer>
        <th style="width: 40px">
          <div class="th-wrap is-centered">{{ $t('total') }}</div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap is-numeric">
            {{ Math.round(intensity.intensity) | splitNumberTons }}
          </div>
        </th>
        <th>
          <div class="th-wrap">
            <b-tooltip :label="$t('display')" type="is-black">
              <b-button
                size="is-small"
                icon-right="bar-chart"
                @click="plotsVisible = true"
              />
            </b-tooltip>
            <b-tooltip :label="$t('download')" type="is-black">
              <b-button
                size="is-small"
                icon-right="download"
                @click="exportTable()"
              />
            </b-tooltip>
          </div>
        </th>
      </template>
    </b-table>
    <b-modal :active.sync="plotsVisible" has-modal-card :width="1100">
      <div class="modal-card" style="width: 1100px">
        <section class="modal-card-body">
          <plots-regulatory
            :title="graphicTitle"
            :data1="graphicDataTons1"
            :data2="graphicDataTons2"
            :data3="graphicDataTons3"
            :data4="graphicDataTons4"
            :data5="graphicDataTons5"
            :data6="graphicDataTons6"
            :drill1="drillDataTons1"
            :drill2="drillDataTons2"
            :drill3="drillDataTons3"
            :drill4="drillDataTons4"
            :drill5="drillDataTons5"
            :drill6="drillDataTons6"
          />
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  DetailedCarbonIntensity,
  DetailedCarbonIntensities,
  CarbonIntensity,
  CarbonIntensities
} from '@/models/carbon/CarbonIntensity.js'
import '@/plugins/highcharts.js'
import { createExportFile } from '@/utils/files'
import Purchase from '@/models/carbon/Purchase.js'
import Modules from '@/models/Modules.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'RegulatoryInventory',
  components: {
    'plots-regulatory': () =>
      import('@/components/carbon/results/PlotsRegulatory.vue')
  },
  data () {
    return {
      graphicTitle: '',
      graphicData1: 100.0,
      graphicData2: 100.0,
      graphicData3: 100.0,
      graphicData4: 100.0,
      graphicData5: 100.0,
      graphicData6: 100.0,
      drillData1: [],
      drillData2: [],
      drillData3: [],
      drillData4: [],
      drillData5: [],
      drillData6: [],
      plotsVisible: false
    }
  },
  setup () {
    const ghgiStore = useGHGIStore()
    const coreStore = useCoreStore()
    return { ghgiStore, coreStore }
  },
  computed: {
    ghgi: function () {
      return this.ghgiStore.item
    },
    modules: function () {
      return this.coreStore.activeModules(false)
    },
    graphicDataTons1: function () {
      return this.graphicData1 / 1000
    },
    graphicDataTons2: function () {
      return this.graphicData2 / 1000
    },
    graphicDataTons3: function () {
      return this.graphicData3 / 1000
    },
    graphicDataTons4: function () {
      return this.graphicData4 / 1000
    },
    graphicDataTons5: function () {
      return this.graphicData5 / 1000
    },
    graphicDataTons6: function () {
      return this.graphicData6 / 1000
    },
    drillDataTons1: function () {
      let drillDataTons1 = []
      for (let source of this.drillData1) {
        drillDataTons1.push([source[0], source[1] / 1000])
      }
      return drillDataTons1
    },
    drillDataTons2: function () {
      let drillDataTons2 = []
      for (let source of this.drillData2) {
        drillDataTons2.push([source[0], source[1] / 1000])
      }
      return drillDataTons2
    },
    drillDataTons3: function () {
      let drillDataTons3 = []
      for (let source of this.drillData3) {
        drillDataTons3.push([source[0], source[1] / 1000])
      }
      return drillDataTons3
    },
    drillDataTons4: function () {
      let drillDataTons4 = []
      for (let source of this.drillData4) {
        drillDataTons4.push([source[0], source[1] / 1000])
      }
      return drillDataTons4
    },
    drillDataTons5: function () {
      let drillDataTons5 = []
      for (let source of this.drillData5) {
        drillDataTons5.push([source[0], source[1] / 1000])
      }
      return drillDataTons5
    },
    drillDataTons6: function () {
      let drillDataTons6 = []
      for (let source of this.drillData6) {
        drillDataTons6.push([source[0], source[1] / 1000])
      }
      return drillDataTons6
    },
    intensity: function () {
      let intensity = new CarbonIntensities()
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[5].intensity.intensity,
          this.emissionsPostes[5].intensity.uncertainty
        )
      )
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[8].intensity.intensity,
          this.emissionsPostes[8].intensity.uncertainty
        )
      )
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[14].intensity.intensity,
          this.emissionsPostes[14].intensity.uncertainty
        )
      )
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[20].intensity.intensity,
          this.emissionsPostes[20].intensity.uncertainty
        )
      )
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[25].intensity.intensity,
          this.emissionsPostes[25].intensity.uncertainty
        )
      )
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[26].intensity.intensity,
          this.emissionsPostes[26].intensity.uncertainty
        )
      )
      return intensity.sum()
    },
    emissionsPostes: function () {
      return [
        {
          poste: '1.1',
          cat: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-1p1'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.2',
          cat: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-1p2'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.3',
          cat: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-1p3'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.4',
          cat: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-1p4'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.5',
          cat: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-1p5'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsRegulatoryInventory.sub-total'),
          cat: '1',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '2.1',
          cat: '2',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-2p1'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '2.2',
          cat: '2',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-2p2'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsRegulatoryInventory.sub-total'),
          cat: '2',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.1',
          cat: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-3p1'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.2',
          cat: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-3p2'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.3',
          cat: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-3p3'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.4',
          cat: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-3p4'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.5',
          cat: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-3p5'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsRegulatoryInventory.sub-total'),
          cat: '3',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '4.1',
          cat: '4',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-4p1'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '4.2',
          cat: '4',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-4p2'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '4.3',
          cat: '4',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-4p3'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '4.4',
          cat: '4',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-4p4'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '4.5',
          cat: '4',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-4p5'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsRegulatoryInventory.sub-total'),
          cat: '4',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '5.1',
          cat: '5',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-5p1'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '5.2',
          cat: '5',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-5p2'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '5.3',
          cat: '5',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-5p3'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '5.4',
          cat: '5',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-5p4'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsRegulatoryInventory.sub-total'),
          cat: '5',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '6.1',
          cat: '6',
          computed: false,
          posteDef: this.$t('compCarbonResultsRegulatoryInventory.post-6p1'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        }
      ]
    }
  },
  methods: {
    isDetailed (poste) {
      return poste.intensity instanceof DetailedCarbonIntensity
    },
    exportTable () {
      let csvContent = [
        Object.keys(this.emissionsPostes[0])
          .filter((column) => !column.startsWith('_'))
          .join('\t') + '\t uncertainty',
        ...this.emissionsPostes.map(function (item) {
          let toReturn = ''
          for (let colName of Object.keys(item).filter(
            (column) => !column.startsWith('_')
          )) {
            if (colName === 'intensity') {
              toReturn += Math.round(item[colName].intensity) + '\t'
              toReturn += Math.round(item[colName].uncertainty)
            } else {
              toReturn += item[colName] + '\t'
            }
          }
          return toReturn
        })
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')
      createExportFile(csvContent, 'regulatory')
    },
    setGraphicData () {
      this.drillData1 = []
      this.drillData2 = []
      this.drillData3 = []
      this.drillData4 = []
      this.drillData5 = []
      this.drillData6 = []
      this.graphicData1 = Math.round(
        this.emissionsPostes[5].intensity.intensity
      )
      this.graphicData2 = Math.round(
        this.emissionsPostes[8].intensity.intensity
      )
      this.graphicData3 = Math.round(
        this.emissionsPostes[14].intensity.intensity
      )
      this.graphicData4 = Math.round(
        this.emissionsPostes[20].intensity.intensity
      )
      this.graphicData5 = Math.round(
        this.emissionsPostes[25].intensity.intensity
      )
      this.graphicData6 = Math.round(
        this.emissionsPostes[26].intensity.intensity
      )
      for (let i = 0; i < 5; i++) {
        if (this.emissionsPostes[i].intensity.intensity > 0) {
          this.drillData1.push([
            this.emissionsPostes[i].posteDef,
            Math.round(this.emissionsPostes[i].intensity.intensity)
          ])
        }
      }
      for (let i of [6, 7]) {
        if (this.emissionsPostes[i].intensity.intensity > 0) {
          this.drillData2.push([
            this.emissionsPostes[i].posteDef,
            Math.round(this.emissionsPostes[i].intensity.intensity)
          ])
        }
      }
      for (let i = 9; i < 14; i++) {
        if (this.emissionsPostes[i].intensity.intensity > 0) {
          this.drillData3.push([
            this.emissionsPostes[i].posteDef,
            Math.round(this.emissionsPostes[i].intensity.intensity)
          ])
        }
      }
      for (let i = 15; i < 20; i++) {
        if (this.emissionsPostes[i].intensity.intensity > 0) {
          this.drillData4.push([
            this.emissionsPostes[i].posteDef,
            Math.round(this.emissionsPostes[i].intensity.intensity)
          ])
        }
      }
      for (let i = 21; i < 25; i++) {
        if (this.emissionsPostes[i].intensity.intensity > 0) {
          this.drillData5.push([
            this.emissionsPostes[i].posteDef,
            Math.round(this.emissionsPostes[i].intensity.intensity)
          ])
        }
      }
      if (this.emissionsPostes[26].intensity.intensity > 0) {
        this.drillData6.push([
          this.emissionsPostes[26].posteDef,
          Math.round(this.emissionsPostes[26].intensity.intensity)
        ])
      }
    },
    processBuildings () {
      let results = this.ghgi.emissions.buildings
      let index1p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '1.1'
      )
      let index1p4 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '1.4'
      )
      let index2p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '2.1'
      )
      let index2p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '2.2'
      )
      let index4p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '4.1'
      )
      let index4p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '4.2'
      )

      // heatings intensity
      this.emissionsPostes[index1p1]._intensities.add(
        new DetailedCarbonIntensity(
          results.heatings.controled.co2,
          results.heatings.controled.ch4,
          results.heatings.controled.n2o,
          results.heatings.controled.other,
          results.heatings.controled.combustion.intensity,
          results.heatings.controled.combustion.uncertainty
        )
      )
      this.emissionsPostes[index1p1].computed = true
      this.emissionsPostes[index2p2]._intensities.add(
        new CarbonIntensity(
          results.heatings.uncontroled.combustion.intensity,
          results.heatings.uncontroled.combustion.uncertainty
        )
      )
      this.emissionsPostes[index2p2].computed = true
      this.emissionsPostes[index4p1]._intensities.add(
        new CarbonIntensity(
          results.heatings.controled.upstream.intensity,
          results.heatings.controled.upstream.uncertainty
        )
      )
      this.emissionsPostes[index4p1]._intensities.add(
        new CarbonIntensity(
          results.heatings.uncontroled.upstream.intensity,
          results.heatings.uncontroled.upstream.uncertainty
        )
      )
      // electricity intensity
      this.emissionsPostes[index2p1]._intensities.add(
        new CarbonIntensity(
          results.electricity.intensity.combustion.intensity,
          results.electricity.intensity.combustion.uncertainty
        )
      )
      this.emissionsPostes[index2p1].computed = true
      this.emissionsPostes[index4p1]._intensities.add(
        new CarbonIntensity(
          results.electricity.intensity.upstream.intensity,
          results.electricity.intensity.upstream.uncertainty
        )
      )
      this.emissionsPostes[index4p1].computed = true
      // refrigerants intensity
      this.emissionsPostes[index1p4]._intensities.add(
        new DetailedCarbonIntensity(
          0.0,
          0.0,
          0.0,
          results.refrigerants.intensity.intensity,
          results.refrigerants.intensity.intensity,
          results.refrigerants.intensity.uncertainty
        )
      )
      this.emissionsPostes[index1p4].computed = true
      // water intensity
      this.emissionsPostes[index4p1]._intensities.add(results.water.intensity)
      this.emissionsPostes[index4p1].computed = true
      // constrcution intensity
      this.emissionsPostes[index4p2]._intensities.add(
        results.construction.intensity
      )
      this.emissionsPostes[index4p2].computed = true
    },
    processVehicles () {
      let results = this.ghgi.emissions.vehicles
      let index1p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '1.2'
      )
      let index4p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '4.1'
      )
      let index3p5 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.5'
      )
      this.emissionsPostes[index1p2]._intensities.add(
        new DetailedCarbonIntensity(
          results.controled.co2,
          results.controled.ch4,
          results.controled.n2o,
          results.controled.other,
          results.controled.combustion.intensity,
          results.controled.combustion.uncertainty
        )
      )
      this.emissionsPostes[index1p2].computed = true
      this.emissionsPostes[index4p1]._intensities.add(
        new CarbonIntensity(
          results.controled.upstream.intensity,
          results.controled.upstream.uncertainty
        )
      )
      this.emissionsPostes[index4p1].computed = true
      this.emissionsPostes[index3p5]._intensities.add(
        new CarbonIntensity(
          results.controled.manufacturing.intensity,
          results.controled.manufacturing.uncertainty
        )
      )
      this.emissionsPostes[index3p5]._intensities.add(
        new CarbonIntensity(
          results.uncontroled.intensity,
          results.uncontroled.uncertainty
        )
      )
      this.emissionsPostes[index3p5].computed = true
    },
    processCommutes () {
      let results = this.ghgi.emissions.commutes
      // add the value to the right post
      let index3p3 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.3'
      )
      this.emissionsPostes[index3p3]._intensities.add(results.intensity)
      this.emissionsPostes[index3p3].computed = true
    },
    processFoods () {
      let results = this.ghgi.emissions.foods
      // add the value to the right post
      let index4p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '4.1'
      )
      this.emissionsPostes[index4p1]._intensities.add(results.intensity)
      this.emissionsPostes[index4p1].computed = true
    },
    processTravels () {
      let results = this.ghgi.emissions.travels
      // add the value to the right post
      let index3p5 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.5'
      )
      this.emissionsPostes[index3p5]._intensities.add(results.intensity)
      this.emissionsPostes[index3p5].computed = true
    },
    processDevices () {
      let results = this.ghgi.emissions.devices
      // add the value to the right post
      let index4p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '4.2'
      )
      this.emissionsPostes[index4p2]._intensities.add(results.intensity)
      this.emissionsPostes[index4p2].computed = true
    },
    processPurchases () {
      let results = this.ghgi.emissions.purchases
      // add the value to the right post
      for (let scat of Object.keys(results.catV5)) {
        let cindex = this.emissionsPostes.findIndex((obj) => obj.poste === scat)
        if (cindex !== -1) {
          this.emissionsPostes[cindex]._intensities.add(results.catV5[scat])
        }
      }
      // set as computed all purchases scopes
      for (let catV5 of Purchase.getCatV5()) {
        let cindex = this.emissionsPostes.findIndex(
          (obj) => obj.poste === catV5.toString()
        )
        if (cindex !== -1) {
          this.emissionsPostes[cindex].computed = true
        }
      }
    },
    processRActivities () {
      let results = this.ghgi.emissions.ractivities
      // add the value to the right post
      for (let key of Object.keys(results.intensitiesV5)) {
        let index = this.emissionsPostes.findIndex((obj) => obj.poste === key)
        if (key.startsWith('1.')) {
          this.emissionsPostes[index]._intensities.add(
            new DetailedCarbonIntensity(
              results.intensitiesV5[key].co2,
              results.intensitiesV5[key].ch4,
              results.intensitiesV5[key].n2o,
              results.intensitiesV5[key].other,
              results.intensitiesV5[key].intensity,
              results.intensitiesV5[key].uncertainty
            )
          )
        } else {
          this.emissionsPostes[index]._intensities.add(
            results.intensitiesV5[key]
          )
        }
        this.emissionsPostes[index].computed = true
      }
    },
    updateValues () {
      this.emissionsPostes[5]._intensities = new CarbonIntensities()
      for (let i = 0; i < 5; i++) {
        this.emissionsPostes[5]._intensities.add(
          this.emissionsPostes[i]._intensities
        )
      }
      this.emissionsPostes[8]._intensities = new CarbonIntensities()
      this.emissionsPostes[8]._intensities.add(
        this.emissionsPostes[6]._intensities
      )
      this.emissionsPostes[8]._intensities.add(
        this.emissionsPostes[7]._intensities
      )

      this.emissionsPostes[14]._intensities = new CarbonIntensities()
      for (let i = 9; i < 14; i++) {
        this.emissionsPostes[14]._intensities.add(
          this.emissionsPostes[i]._intensities
        )
      }
      this.emissionsPostes[20]._intensities = new CarbonIntensities()
      for (let i = 15; i < 20; i++) {
        this.emissionsPostes[20]._intensities.add(
          this.emissionsPostes[i]._intensities
        )
      }
      this.emissionsPostes[25]._intensities = new CarbonIntensities()
      for (let i = 21; i < 25; i++) {
        this.emissionsPostes[25]._intensities.add(
          this.emissionsPostes[i]._intensities
        )
      }
      for (let emission of this.emissionsPostes) {
        emission.intensity = emission._intensities.sum()
      }
    },
    process () {
      // First reset values
      for (let emission of this.emissionsPostes) {
        if (parseFloat(emission.poste) <= 1.5) {
          emission._intensities = new DetailedCarbonIntensities()
        } else {
          emission._intensities = new CarbonIntensities()
        }
      }
      this.ghgiStore.compute()
      if (this.modules.includes(Modules.BUILDINGS)) {
        this.processBuildings()
      }
      if (this.modules.includes(Modules.VEHICLES)) {
        this.processVehicles()
      }
      if (this.modules.includes(Modules.COMMUTES)) {
        this.processCommutes()
      }
      if (this.modules.includes(Modules.TRAVELS)) {
        this.processTravels()
      }
      if (this.modules.includes(Modules.DEVICES)) {
        this.processDevices()
      }
      if (this.modules.includes(Modules.PURCHASES)) {
        this.processPurchases()
      }
      if (this.modules.includes(Modules.FOODS)) {
        this.processFoods()
      }
      if (this.modules.includes(Modules.RACTIVITIES)) {
        this.processRActivities()
      }
      // update final values
      this.updateValues()
      // affichage des graphs
      this.setGraphicData()
    }
  },
  mounted () {
    this.process()
  }
}
</script>
